import authSession from "../lib/authSession";
import React from "react";
import NavBar from "../components/UserNavBar2";
import {useState, useEffect} from "react";
import {API_URL, IMAGE_HOST} from "../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import Toast from "../components/Toast";
import {useNavigate, useParams} from "react-router-dom";
import {CourseCollapsible} from "../components/Collapsible";
import SmallCircleProgress from "../components/SmallCircleProgress";
import CircleProgress from "../components/CircleProgress";
import PaystackPaymentButton from "../components/paystackButton";

const LearnPath = () => {
  const token = authSession.getToken();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(false);
  const [learningPath, setLearningPath] = useState(null);
  const [progress, setProgress] = useState(0);
  const [user, setUser] = useState(null);

  const [isSuccess, setIsSuccess] = React.useState(true);
  const [toast, setToast] = useState(null);
  const showToast = React.useCallback((message, success = true) => {
    setToast(message);
    setIsSuccess(success);

    setTimeout(() => setToast(null), 5000); // Hide after 5s
  }, []);

  const navigate = useNavigate();

  const {id} = useParams();
  useEffect(() => {
    function calculateLearningPathProgress(response) {
      const courses = response.courses;

      if (!courses || courses.length === 0) return 0;

      const totalCourseProgress = courses.reduce((sum, course) => {
        const courseProgress = Number(course.progress) || 0;
        return sum + courseProgress;
      }, 0);

      return Math.round(totalCourseProgress / courses.length);
    }

    const fetchLearningPath = async () => {
      try {
        const response = await fetch(`${API_URL}/api/learning-path-full/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch learning path");
        }
        const data = await response.json();
        setProgress(calculateLearningPathProgress(data));
        setLearningPath(data);
        setUser(data.user);
      } catch (err) {
        showToast(err.message, false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLearningPath();
  }, [id, token]); // Refetch when id or token changes

  const checkProceed = async () => {
    setIsLoading2(true);
    try {
      const response = await fetch(`${API_URL}/api/check/plan/${id}/path`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      if (data.proceed === false) {
        showToast(data.message, false);
        return;
      } else {
        navigate(`/content-library/path/${id}/read`);
      }
    } catch (err) {
      showToast(err.message, false);
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div>
      <div className="navHeader">
        <NavBar title="Content Library" />
      </div>
      <div className="main-body main-body5 main-body4">
        {toast && <Toast message={toast} onClose={() => setToast(null)} isSuccess={isSuccess} />}
        {isLoading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : learningPath !== null ? (
          <div className="sub-body">
            <div className="courseHeader">
              <div className="headerContent">
                <div className="headerImageCon">
                  <img
                    src={
                      learningPath.image != null
                        ? `${IMAGE_HOST}${learningPath.image}`
                        : "/images/sample_image.png"
                    }
                    alt="course-image"
                    className="headerImage"
                  />
                </div>

                <div className="headerContent">
                  <div className="headerTitle">
                    <div>
                      <span>{learningPath.title}</span>
                    </div>
                    <span
                      className={`${
                        learningPath.price === 0 || learningPath.paid
                          ? "badge course-price"
                          : "badge course-price-paid"
                      }`}
                    >
                      {learningPath.price == 0
                        ? "Free"
                        : learningPath.paid
                        ? "Purchased"
                        : new Intl.NumberFormat("en-NG", {
                            style: "currency",
                            currency: "NGN",
                            minimumFractionDigits: 2
                          }).format(learningPath.price)}
                    </span>

                    <div className="headerDesc">
                      <span>{learningPath.description}</span>
                    </div>
                    {learningPath.paid || learningPath.price == 0 ? (
                      <button
                        className="btn continueBtn"
                        onClick={() => {
                          checkProceed();
                        }}
                        disabled={isLoading2}
                      >
                        {isLoading2 ? (
                          <div
                            className="spinner-border text-light "
                            role="status"
                            style={{height: "20px", width: "20px", marginBottom: "0px"}}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span>
                            {progress === 100
                              ? "Restart this learning path"
                              : progress === 0
                              ? "Start this learning path"
                              : "Continue this learning path"}
                          </span>
                        )}
                      </button>
                    ) : (
                      user &&
                      user && (
                        <PaystackPaymentButton
                          itemId={learningPath.id}
                          userId={user.id}
                          itemType="path"
                          amount={learningPath.price}
                          email={user.email}
                          showToast={showToast}
                          onPaymentSuccess={() => {
                            /* Not directly used for final verification, handled by redirect */
                          }}
                          onPaymentClose={() => {
                            /* Optional: handle user closing payment modal */
                          }}
                          disabled={!user || isLoading}
                        />
                      )
                    )}
                  </div>

                  <div className="circleProgress">
                    <CircleProgress progress={progress} />
                  </div>
                </div>
              </div>
            </div>

            <div className="mobileCourseHeader">
              <div className="mheaderContent">
                <div className="mheaderImageCon">
                  <img
                    src={
                      learningPath.image != null
                        ? `${IMAGE_HOST}${learningPath.image}`
                        : "/images/sample_image.png"
                    }
                    alt="course-image"
                    className="mheaderImage"
                  />
                </div>

                <div className="mheaderContent">
                  <div className="mheaderTitle">
                    <div>
                      <span>{learningPath.title}</span>
                    </div>
                    <span
                      className={`${
                        learningPath.price === 0 || learningPath.paid
                          ? "badge course-price"
                          : "badge course-price-paid"
                      }`}
                    >
                      {learningPath.price == 0
                        ? "Free"
                        : learningPath.paid
                        ? "Purchased"
                        : new Intl.NumberFormat("en-NG", {
                            style: "currency",
                            currency: "NGN",
                            minimumFractionDigits: 2
                          }).format(learningPath.price)}
                    </span>

                    <div className="headerDesc">
                      <span>{learningPath.description}</span>
                    </div>
                    {learningPath.paid || learningPath.price == 0 ? (
                      <button
                        className="btn continueBtn"
                        onClick={() => {
                          navigate(`/content-library/path/${learningPath.id}/read`);
                        }}
                      >
                        <span>
                          {progress === 100
                            ? "Restart this learning path"
                            : progress === 0
                            ? "Start this learning path"
                            : "Continue this learning path"}
                        </span>
                      </button>
                    ) : (
                      user && (
                        <PaystackPaymentButton
                          itemId={learningPath.id}
                          userId={user.id}
                          itemType="path"
                          amount={learningPath.price}
                          email={user.email}
                          showToast={showToast}
                          onPaymentSuccess={() => {
                            /* Not directly used for final verification, handled by redirect */
                          }}
                          onPaymentClose={() => {
                            /* Optional: handle user closing payment modal */
                          }}
                          disabled={!user || isLoading}
                        />
                      )
                    )}
                  </div>

                  <div className="mcircleProgress">
                    <SmallCircleProgress progress={progress} />
                  </div>
                </div>
              </div>
            </div>

            <div className="courseBody">
              {!learningPath ? (
                <div className="noObjects noObjects100 mt-4">Learning path not found</div>
              ) : learningPath.courses.length === 0 ? (
                <div className="noObjects noObjects100 mt-4">No Courses here</div>
              ) : (
                learningPath.courses.map((section, index) => (
                  <CourseCollapsible key={index} progress={section.progress} {...section} />
                ))
              )}
            </div>
          </div>
        ) : (
          <div className="noObjects">Learning Path not Found!</div>
        )}
      </div>
    </div>
  );
};

export default LearnPath;
